// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__x74u1","empty":"ModalGraph_empty__-ncT7"};